import React from 'react';
import {View} from 'react-native';

import Text from '/component/base/Text';
import {DownlineProfile} from '/constant/TestIDs';
import testProperties from '/util/testing/testProperties';

import {styles} from './TaskDetails.style';
interface TaskDetailsContentProps {
  taskDetailsList: string[];
  style: {
    base?: StyleProp<ViewStyle>;
    listItem?: StyleProp<ViewStyle>;
  };
}

export const TaskDetailsContent: React.FC<TaskDetailsContentProps> = ({
  taskDetailsList,
  style: styleProp,
}) => {
  return (
    <View style={styleProp?.base || styles.detailsListItemContainer}>
      {taskDetailsList?.map((taskList: any, index: any) => {
        const label = taskList?.split('|');
        return (
          <View
            key={index}
            style={{...styles.detailsListItem, ...(styleProp?.listItem || {})}}
            {...testProperties(
              `${DownlineProfile.cjTaskDetailBulletView}${index}`,
              true,
            )}>
            <Text style={styles.bullet}>{'\u2022'}</Text>
            <Text>
              {label?.map((m: any, index: any) => (
                <Text
                  variant="button"
                  style={
                    index === 1
                      ? styles.taskDetailsTextLabel
                      : styles.taskDetailContentText
                  }
                  {...testProperties(
                    `${DownlineProfile.cjTaskDetailBullet}-${index}`,
                    true,
                  )}>
                  {m}
                </Text>
              ))}
            </Text>
          </View>
        );
      })}
    </View>
  );
};
